import { network } from './network';

export async function authByTicket(opts) {
	const res = await network({
		url: '/api/v1/user/auth_by_ticket',
		method: 'post',
		headers: {},
		params: {
			ticket: opts.ticket
		},
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getUserInfo(opts) {
	const res = await network({
		url: '/api/v1/user_info',
		method: 'post',
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		},
		params: {},
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getAppGlobalInfo(opts) {
	const res = await network({
		url: '/api/v1/app/global',
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function loginout(opts) {
	const res = await network({
		url: '/api/v1/user/logout',
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}
